import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import router from '@/router';

export default [
  {
    path: '/diary',
    component: () => import('@/views/diary/index.vue'),
    meta: {
      isHeader: true,
      isHeaderPrimary: true,
      isNav: true,
      titleName: '다이어리',
      isBack: false,
      isHome: true,
      isPlus: true
    }
  },
  {
    path: '/diary/user/:diaryNo',
    component: () => import('@/views/diary/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      titleName: '일정 더보기',
      isBack: true,
      isHome: true,
      isEdit: true,
      isDelete: true,
      isFooter: true
    }
  },
  {
    path: '/diary/church/:churchDiaryNo',
    component: () => import('@/views/diary/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      titleName: '교회 일정 더보기',
      isBack: true,
      isHome: true,
      isPlus: false,
      isFooter: true
    }
  },
  {
    path: '/diary/form',
    component: () => import('@/views/diary/DiaryForm.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      titleName: '일정 등록/수정',
      isBack: true,
      isHome: true,
      isFooter: true
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },

  {
    path: '/diary/fixed/form',
    component: () => import('@/views/diary/DiaryFixedForm.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      titleName: '일정 등록/수정',
      isBack: true,
      isHome: true,
      isFooter: true
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },

  {
    path: '/diary/form/:diaryNo',
    component: () => import('@/views/diary/DiaryForm.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      titleName: '일정 등록/수정',
      isBack: true,
      isHome: true,
      isFooter: true
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  }
];
